(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__cgInit) return;
    root.__cgInit = true;
    var revealOn = root.getAttribute('data-reveal') === 'on';

    // ── Dominant-color panel backgrounds ──────────────────────────────
    function rgbToHsl(r, g, b) {
      r /= 255; g /= 255; b /= 255;
      var max = Math.max(r, g, b), min = Math.min(r, g, b), h = 0, s = 0, l = (max + min) / 2, d = max - min;
      if (d) {
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
        else if (max === g) h = (b - r) / d + 2;
        else h = (r - g) / d + 4;
        h /= 6;
      }
      return [h, s, l];
    }
    function hsl(h, s, l) { return 'hsl(' + Math.round(h * 360) + ' ' + Math.round(s * 100) + '% ' + Math.round(l * 100) + '%)'; }

    // Card bindings live in bindCards() so they can be re-applied after the
    // filter script swaps in fresh cards (fired via the 'cg:swapped' event).
    function applyDominant(img) {
      try {
        var w = 44, h = 44, c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, w, h);
        var data = ctx.getImageData(0, 0, w, h).data, buckets = {};
        for (var i = 0; i < data.length; i += 4) {
          var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
          if (a < 128) continue;
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b), lum = (mx + mn) / 510;
          if (lum > 0.93 || lum < 0.07) continue;
          var sat = mx === 0 ? 0 : (mx - mn) / mx, wt = 1 + sat * 4;
          var key = ((r >> 4) << 8) | ((g >> 4) << 4) | (b >> 4);
          var bk = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
          bk.n += wt; bk.r += r * wt; bk.g += g * wt; bk.b += b * wt;
        }
        var best = null;
        for (var k in buckets) if (!best || buckets[k].n > best.n) best = buckets[k];
        if (!best) return;
        var c1 = rgbToHsl(best.r / best.n, best.g / best.n, best.b / best.n);
        var sa = Math.min(1, Math.max(0.78, c1[1] * 1.4));
        var panel = img.closest('[data-cg-panel]');
        if (panel) panel.style.background = 'radial-gradient(85% 80% at 50% 30%, ' + hsl(c1[0], sa, 0.54) + ', ' + hsl(c1[0], 1, 0.3) + ')';
      } catch (e) { /* tainted / CORS — keep fallback gradient */ }
    }
    function bindCards() {
    root.querySelectorAll('[data-cg-img]').forEach(function (img) {
      if (img.complete && img.naturalWidth) applyDominant(img);
      else img.addEventListener('load', function () { applyDominant(img); });
    });

    // ── Reveal on scroll ──────────────────────────────────────────────
    if (revealOn) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          io.unobserve(el);
          try {
            el.animate([{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'none' }],
              { duration: 550, easing: 'cubic-bezier(0.22,1,0.36,1)', fill: 'forwards' });
          } catch (err) { el.style.opacity = '1'; }
          setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'none'; }, 800);
        });
      }, { threshold: 0.12 });
      root.querySelectorAll('[data-reveal-id]').forEach(function (el) { io.observe(el); });
    }

    // ── Quantity steppers ─────────────────────────────────────────────
    root.querySelectorAll('[data-cg-form]').forEach(function (form) {
      var qty = form.querySelector('[data-cg="qty"]');
      form.querySelector('[data-cg-dec]').addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      });
      form.querySelector('[data-cg-inc]').addEventListener('click', function () {
        qty.value = (parseInt(qty.value, 10) || 1) + 1;
      });

      // ── AJAX add to cart (no redirect) ──────────────────────────────
      // In-flight lock: ignore further clicks while a request is pending so
      // spam-clicking can't fire a request storm that trips Shopify's edge
      // rate-limiter (429/430) and freezes the UI.
      var inFlight = false;
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (inFlight) return;
        var btn = form.querySelector('[data-cg="add"]');
        inFlight = true;
        btn.classList.add('is-loading');
        fetch(form.action + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: form.querySelector('[name=id]').value, quantity: parseInt(qty.value, 10) || 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            setTimeout(function () { btn.classList.remove('is-added'); }, 1200);
            // Let the theme's cart drawer / count update.
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (window.Shopify && Shopify.onCartUpdate) { /* theme hook */ }
          })
          .catch(function () { btn.classList.remove('is-loading'); })
          .then(function () { inFlight = false; });
      });
    });
    }

    bindCards();
    root.addEventListener('cg:swapped', bindCards);
  }

  document.querySelectorAll('[data-cg-root]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-cg-root]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__cgInit) return;
    root.__cgInit = true;
    var revealOn = root.getAttribute('data-reveal') === 'on';
    var rmotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ── Dominant-color panel backgrounds ──────────────────────────────
    function rgbToHsl(r, g, b) {
      r /= 255; g /= 255; b /= 255;
      var max = Math.max(r, g, b), min = Math.min(r, g, b), h = 0, s = 0, l = (max + min) / 2, d = max - min;
      if (d) {
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
        else if (max === g) h = (b - r) / d + 2;
        else h = (r - g) / d + 4;
        h /= 6;
      }
      return [h, s, l];
    }
    function hsl(h, s, l) { return 'hsl(' + Math.round(h * 360) + ' ' + Math.round(s * 100) + '% ' + Math.round(l * 100) + '%)'; }

    function applyDominant(img) {
      try {
        var w = 44, h = 44, c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, w, h);
        var data = ctx.getImageData(0, 0, w, h).data, buckets = {};
        for (var i = 0; i < data.length; i += 4) {
          var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
          if (a < 128) continue;
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b), lum = (mx + mn) / 510;
          if (lum > 0.93 || lum < 0.07) continue;
          var sat = mx === 0 ? 0 : (mx - mn) / mx, wt = 1 + sat * 4;
          var key = ((r >> 4) << 8) | ((g >> 4) << 4) | (b >> 4);
          var bk = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
          bk.n += wt; bk.r += r * wt; bk.g += g * wt; bk.b += b * wt;
        }
        var best = null;
        for (var k in buckets) if (!best || buckets[k].n > best.n) best = buckets[k];
        if (!best) return;
        var c1 = rgbToHsl(best.r / best.n, best.g / best.n, best.b / best.n);
        var sa = Math.min(1, Math.max(0.78, c1[1] * 1.4));
        var panel = img.closest('[data-cg-panel]');
        if (panel) panel.style.background = 'radial-gradient(85% 80% at 50% 30%, ' + hsl(c1[0], sa, 0.54) + ', ' + hsl(c1[0], 1, 0.3) + ')';
      } catch (e) { /* tainted / CORS — keep fallback gradient */ }
    }
    root.querySelectorAll('[data-cg-img]').forEach(function (img) {
      if (img.complete && img.naturalWidth) applyDominant(img);
      else img.addEventListener('load', function () { applyDominant(img); });
    });

    // ── Reveal on scroll ──────────────────────────────────────────────
    if (revealOn) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          io.unobserve(el);
          try {
            el.animate([{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'none' }],
              { duration: 550, easing: 'cubic-bezier(0.22,1,0.36,1)', fill: 'forwards' });
          } catch (err) { el.style.opacity = '1'; }
          setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'none'; }, 800);
        });
      }, { threshold: 0.12 });
      root.querySelectorAll('[data-reveal-id]').forEach(function (el) { io.observe(el); });
    }

    // ── Float-up "+ price" on Add tap ─────────────────────────────────
    // Each tap spawns its own label, so rapid taps stack independently. The
    // label rises ~64px and fades over 1.7s, with a slight horizontal jitter.
    function spawnFloat(form) {
      if (rmotion) return;
      var footer = form.closest('.cg__footer');
      var priceEl = footer && footer.querySelector('[data-cg="price"]');
      var price = priceEl ? priceEl.textContent.trim() : '';
      var f = document.createElement('span');
      f.className = 'cg__float';
      f.textContent = '+ ' + price;
      f.style.marginLeft = (Math.random() * 16 - 8).toFixed(1) + 'px';
      form.appendChild(f);
      if (f.animate) {
        var a = f.animate([
          { transform: 'translate(-50%, 8px)',  opacity: 0 },
          { transform: 'translate(-50%, -8px)', opacity: 1, offset: 0.2 },
          { transform: 'translate(-50%, -64px)', opacity: 0 }
        ], { duration: 1700, easing: 'cubic-bezier(0.22,1,0.36,1)' });
        a.onfinish = function () { f.remove(); };
      } else {
        setTimeout(function () { f.remove(); }, 1700);
      }
    }
    function bump(btn) {
      if (rmotion || !btn.animate) return;
      try { btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.9)' }, { transform: 'scale(1)' }], { duration: 180, easing: 'ease-out' }); } catch (e) {}
    }

    // ── Add to cart (debounced batch: rapid taps = ONE request) ───────
    // Firing one /cart/add.js per click lets spam-clicking trip Shopify's edge
    // rate-limiter (429/430), which freezes the UI briefly. Instead we count
    // the taps, give instant per-tap feedback, and send a single request with
    // the summed quantity ~450ms after the last tap.
    root.querySelectorAll('[data-cg-form]').forEach(function (form) {
      var pending = 0, timer = null, inFlight = false;
      function flush() {
        if (inFlight || pending < 1) return;
        var idEl = form.querySelector('[name=id]');
        if (!idEl) { pending = 0; return; }
        var qty = pending; pending = 0; inFlight = true;
        fetch(form.action + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: idEl.value, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (window.Shopify && Shopify.onCartUpdate) { /* theme hook */ }
          })
          .catch(function () {})
          .then(function () { inFlight = false; if (pending > 0) flush(); }); // drain taps that arrived mid-request
      }
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = form.querySelector('[data-cg="add"]');
        if (!form.querySelector('[name=id]')) return;
        pending += 1;
        if (btn) { spawnFloat(form); bump(btn); } // instant feedback every tap
        clearTimeout(timer);
        timer = setTimeout(flush, 450);
      });
    });
  }

  document.querySelectorAll('[data-cg-root]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-cg-root]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-collection-gridpage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__cgInit) return;
    root.__cgInit = true;
    var revealOn = root.getAttribute('data-reveal') === 'on';
    var rmotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ── Dominant-color panel backgrounds ──────────────────────────────
    function rgbToHsl(r, g, b) {
      r /= 255; g /= 255; b /= 255;
      var max = Math.max(r, g, b), min = Math.min(r, g, b), h = 0, s = 0, l = (max + min) / 2, d = max - min;
      if (d) {
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
        else if (max === g) h = (b - r) / d + 2;
        else h = (r - g) / d + 4;
        h /= 6;
      }
      return [h, s, l];
    }
    function hsl(h, s, l) { return 'hsl(' + Math.round(h * 360) + ' ' + Math.round(s * 100) + '% ' + Math.round(l * 100) + '%)'; }

    function applyDominant(img) {
      try {
        var w = 44, h = 44, c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, w, h);
        var data = ctx.getImageData(0, 0, w, h).data, buckets = {};
        for (var i = 0; i < data.length; i += 4) {
          var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
          if (a < 128) continue;
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b), lum = (mx + mn) / 510;
          if (lum > 0.93 || lum < 0.07) continue;
          var sat = mx === 0 ? 0 : (mx - mn) / mx, wt = 1 + sat * 4;
          var key = ((r >> 4) << 8) | ((g >> 4) << 4) | (b >> 4);
          var bk = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
          bk.n += wt; bk.r += r * wt; bk.g += g * wt; bk.b += b * wt;
        }
        var best = null;
        for (var k in buckets) if (!best || buckets[k].n > best.n) best = buckets[k];
        if (!best) return;
        var c1 = rgbToHsl(best.r / best.n, best.g / best.n, best.b / best.n);
        var sa = Math.min(1, Math.max(0.78, c1[1] * 1.4));
        var panel = img.closest('[data-cg-panel]');
        if (panel) panel.style.background = 'radial-gradient(85% 80% at 50% 30%, ' + hsl(c1[0], sa, 0.54) + ', ' + hsl(c1[0], 1, 0.3) + ')';
      } catch (e) { /* tainted / CORS — keep fallback gradient */ }
    }

    // ── Float-up "+ price" on Add tap ─────────────────────────────────
    // Each tap spawns its own label, so rapid taps stack independently. The
    // label rises ~64px and fades over 1.7s, with a slight horizontal jitter.
    function spawnFloat(form) {
      if (rmotion) return;
      var footer = form.closest('.cg__footer');
      var priceEl = footer && footer.querySelector('[data-cg="price"]');
      var price = priceEl ? priceEl.textContent.trim() : '';
      var f = document.createElement('span');
      f.className = 'cg__float';
      f.textContent = '+ ' + price;
      f.style.marginLeft = (Math.random() * 16 - 8).toFixed(1) + 'px';
      form.appendChild(f);
      if (f.animate) {
        var a = f.animate([
          { transform: 'translate(-50%, 8px)',  opacity: 0 },
          { transform: 'translate(-50%, -8px)', opacity: 1, offset: 0.2 },
          { transform: 'translate(-50%, -64px)', opacity: 0 }
        ], { duration: 1700, easing: 'cubic-bezier(0.22,1,0.36,1)' });
        a.onfinish = function () { f.remove(); };
      } else {
        setTimeout(function () { f.remove(); }, 1700);
      }
    }
    function bump(btn) {
      if (rmotion || !btn.animate) return;
      try { btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.9)' }, { transform: 'scale(1)' }], { duration: 180, easing: 'ease-out' }); } catch (e) {}
    }

    // Card bindings live in bindCards() so they can be re-applied after the
    // filter script swaps in fresh cards (fired via the 'cg:swapped' event).
    function bindCards() {
      root.querySelectorAll('[data-cg-img]').forEach(function (img) {
        if (img.complete && img.naturalWidth) applyDominant(img);
        else img.addEventListener('load', function () { applyDominant(img); });
      });

      // ── Reveal on scroll ──────────────────────────────────────────────
      if (revealOn) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var el = e.target;
            io.unobserve(el);
            try {
              el.animate([{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'none' }],
                { duration: 550, easing: 'cubic-bezier(0.22,1,0.36,1)', fill: 'forwards' });
            } catch (err) { el.style.opacity = '1'; }
            setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'none'; }, 800);
          });
        }, { threshold: 0.12 });
        root.querySelectorAll('[data-reveal-id]').forEach(function (el) { io.observe(el); });
      }

      // ── Add to cart (debounced batch: rapid taps = ONE request) ───────
      // Firing one /cart/add.js per click lets spam-clicking trip Shopify's
      // edge rate-limiter (429/430), which freezes the UI for a few seconds.
      // Instead we count the taps, give instant per-tap feedback, and send a
      // single request with the summed quantity ~450ms after the last tap.
      root.querySelectorAll('[data-cg-form]').forEach(function (form) {
        var pending = 0, timer = null, inFlight = false;
        function flush() {
          if (inFlight || pending < 1) return;
          var idEl = form.querySelector('[name=id]');
          if (!idEl) { pending = 0; return; }
          var qty = pending; pending = 0; inFlight = true;
          fetch(form.action + '.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: idEl.value, quantity: qty })
          })
            .then(function (r) { return r.json(); })
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              if (window.Shopify && Shopify.onCartUpdate) { /* theme hook */ }
            })
            .catch(function () {})
            .then(function () { inFlight = false; if (pending > 0) flush(); }); // drain taps that arrived mid-request
        }
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var btn = form.querySelector('[data-cg="add"]');
          if (!form.querySelector('[name=id]')) return;
          pending += 1;
          if (btn) { spawnFloat(form); bump(btn); } // instant feedback every tap
          clearTimeout(timer);
          timer = setTimeout(flush, 1000);
        });
      });
    }

    bindCards();
    root.addEventListener('cg:swapped', bindCards);
  }

  document.querySelectorAll('[data-cg-root]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-cg-root]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
